module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_WorkingProfessional-b094d349c693649e00f75a875fc44d79.jpg";